module.exports = "<%=baseUrl%>/4b76590b32dab62bc95c1b7951efae78.swf";